import apolloClient from '../graphql/client/apolloClient';

export default class ApolloFetch {
  constructor(query) {
    this.query = query;
  }

  async getAll(offset, limit, filter) {
    const { query } = this;
    const result = await apolloClient.query({
      query,
      variables: { offset, limit, filter },
    });
    return result.data;
  }

  async getAllNoFilter(offset, limit) {
    const { query } = this;
    const result = await apolloClient.query({
      query,
      variables: { offset, limit },
    });
    return result.data;
  }

  async getDefaults() {
    const { query } = this;
    const result = await apolloClient.query({
      query,
    });
    return result.data;
  }

  async getFiltered(variables) {
    const { query } = this;
    const result = await apolloClient.query({
      query,
      variables,
    });
    return result.data;
  }

  async mutation(variables) {
    const { query } = this;
    const result = await apolloClient.mutate({
      mutation: query,
      variables,
    });
    return result.data;
  }
}
